import Reactour from 'reactour';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';

interface Step {
  selector: string;
  content: ReactNode;
}

interface Props {
  steps: Step[];
  scene: string;
}

export default observer((props: Props) => {
  const { steps, scene } = props;
  const setting = nx.$root.guide[scene];
  const [visible, setVisible] = useState(false);
  const tourRef = useRef(null);
  const latest = useRef(-1);

  useEffect(() => {
    nx.waitToDisplay(steps[0].selector, 300, () => {
      setVisible(true);
    });
  }, [steps]);

  const handleChange = value => {
    if (latest.current !== value) {
      latest.current = value;
      setting.current = value;
      nx.$root.guide.save();
    }
  };

  const handleRequestClose = () => {
    const size = steps.length;
    const next = setting.current + 1;
    setting.current = next < size ? next : size - 1;
    if (size === next) {
      setting.visible = false;
      nx.$root.guide.save();
    }
  };

  if (nx.$root.isInternal) return null;

  return (
    <View>
      {visible && (
        <Reactour
          ref={tourRef}
          closeWithMask={false}
          steps={steps}
          startAt={setting.current}
          goToStep={setting.current}
          isOpen={Boolean(setting.visible)}
          getCurrentStep={handleChange}
          onRequestClose={handleRequestClose}
        />
      )}
    </View>
  );
});
